import { type IframeAdapter } from './IframeAdapter';
import { usePlatform } from '../PlatformContext';

export const useIframe = (): IframeAdapter => usePlatform().iframe;
